import type { ReportCallback } from "web-vitals";

const reportWebVitals = (onPerfEntry?: ReportCallback) => {
	if (!onPerfEntry) return;

	import("web-vitals")
		.then(({ onCLS, onINP, onFCP, onLCP, onTTFB }) => {
			onCLS(onPerfEntry);
			onINP(onPerfEntry); // replaces FID
			onFCP(onPerfEntry);
			onLCP(onPerfEntry);
			onTTFB(onPerfEntry);
		})
		.catch(() => {
			/* optional: ignore load errors */
		});
};

export default reportWebVitals;